module.exports = __webpack_public_path__ + "static/media/visure-service.d20568da.png";